<template>
  <v-container fluid>
    <v-col>
      <v-row class="child-flex">
        <v-card>
          <v-card-text>
            <v-card-title>
              <h1 class="text-h4 mr-2">Dealers</h1>
              <v-icon @click="refreshList">mdi-refresh</v-icon>
              <v-spacer></v-spacer>
              <v-text-field
                @keydown.native.escape="search=''"
                label="Search"
                single-line
                hide-details
                clearable
                v-model="search"
              ></v-text-field>
            </v-card-title>
          </v-card-text>
          <v-data-table
            :headers="tableColumns"
            :items="queriedData"
            item-key="dms-key"
            class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="handleEdit(item)">mdi-pencil</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-row>
    </v-col>
    <v-dialog
      v-model="showCreateCard"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab bottom right color="pink" dark fixed  v-bind="attrs" v-on="on">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <dealer-create-card
        @on-create = "handleEdit($event)"
        @on-close = "showCreateCard = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import DealerCreateCard from './DealerCreateCard'

export default {
  components: {
    [DealerCreateCard.name]: DealerCreateCard
  },
  computed: {
    ...mapState('DealerStore', {
      tableData: 'dealers'
    }),
    queriedData () {
      if (!this.search) {
        return this.tableData
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false
        for (let key of this.propsToSearch) {
          let rowValue = row[key] ? row[key].toString() : ''
          if (
            rowValue.includes &&
            rowValue.toLowerCase().includes(this.search.toLowerCase())
          ) {
            isIncluded = true
          }
        }
        return isIncluded
      })
      return result
    }
  },
  data: function () {
    return {
      search: '',
      propsToSearch: ['dms_key', 'name'],
      showCreateCard: false,
      tableColumns: [
        { text: 'Dealer Id', value: 'dms_key' },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions' }
      ]
    }
  },
  mounted: function () {
    return this.refreshList()
  },
  methods: {
    handleDelete (index, row) {
      alert(`Your want to delete ${row.id}`)
    },
    refreshList () {
      return this.$store.dispatch('DealerStore/fetchDealers').catch(error => {
        this.$flash({
          showClose: true,
          message:
            'Error Loading Dealers. Reload to try again. ' + error.message,
          type: 'error'
        })
      })
    },
    handleEdit (item) {
      this.$router.push({ name: 'edit_dealer_path', params: { id: item.id } })
    }
  }
}
</script>
